<template>
  <LayoutButton
    v-for="(button, index) in buttons"
    :id="button.id"
    :key="index"
    class="mr-2 mr-md-0 ml-md-2"
    :disabled="button.disabled"
    :icon="button.icon"
    :to="button.to"
    variant="btn btn-outline-secondary"
    @click="button.click"
  >
    {{ button.title }}
  </LayoutButton>
</template>

<script setup>
defineProps({ buttons: Array });
</script>
